import React from "react";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import "./App.css";
import "./pages/account/css/accountPage.css";
// import MainLayout from "./components/layout/MainLayout";
import MainLayout from "@/components/layout/MainLayout";
import {RouterContent} from "./router/RouterContent";
import NotFound from "./pages/NotFound";
import ScrollTop from "@/components/ui/ScrollTop";

function App() {
    return (
        <Router>
            <ScrollTop/>
            <MainLayout>
                <Routes>
                    {RouterContent.map((route, index) => (
                        <Route key={index} path={route.path} element={route.element}/>
                    ))}
                    <Route path="*" element={<NotFound/>}/>
                </Routes>
            </MainLayout>
        </Router>
    );
}

export default App;
